import { type KeyboardEventHandler } from 'react';

const onKeyDownOnlyNumbers: KeyboardEventHandler<HTMLInputElement> = event => {
  // Allow only numbers:
  if (
    !/^\d*$/.test(event.key) &&
    event.key !== 'Backspace' &&
    event.key !== 'Delete' &&
    event.key !== 'ArrowLeft' &&
    event.key !== 'ArrowRight' &&
    event.key !== 'ArrowUp' &&
    event.key !== 'ArrowDown' &&
    event.key !== 'Tab'
  ) {
    event.preventDefault();
  }
};

export default onKeyDownOnlyNumbers;
